import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ReservationPopup from "./ReservationPopup"; // путь подкорректируй

export default function ReservationPage() {
  const [guests, setGuests] = useState(2);
  const today = new Date();
  const [currentDate, setCurrentDate] = useState(today);
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();

  // Динамическое время
  const generateTimes = () => {
    const times = [];
    const start = new Date();
    start.setHours(12, 30, 0, 0); // 12:30
    const end = new Date();
    end.setHours(23, 30, 0, 0); // 23:30

    while (start <= end) {
      const hours = start.getHours().toString().padStart(2, "0");
      const minutes = start.getMinutes().toString().padStart(2, "0");
      times.push(`${hours}:${minutes}`);
      start.setMinutes(start.getMinutes() + 15);
    }
    return times;
  };

  const times = generateTimes();
  const [timeIndex, setTimeIndex] = useState(0);
  const time = times[timeIndex];

  const formatDate = (date) =>
    date.toLocaleDateString("en-GB", {
      weekday: "short",
      day: "2-digit",
      month: "short",
    });

  const goPrevDate = () => {
    const prev = new Date(currentDate);
    prev.setDate(currentDate.getDate() - 1);
    if (prev >= new Date().setHours(0, 0, 0, 0)) {
      setCurrentDate(prev);
    }
  };

  const goNextDate = () => {
    const next = new Date(currentDate);
    next.setDate(currentDate.getDate() + 1);
    setCurrentDate(next);
  };

  const handleSearch = () => {
    localStorage.setItem("selectedDate", formatDate(currentDate));
    localStorage.setItem("selectedTime", time);
    localStorage.setItem("selectedGuests", guests.toString());

    setShowPopup(true);
    setTimeout(() => {
      setShowPopup(false);
      navigate("/time");
    }, 2000);
  };

  return (
    <>
      {showPopup && <ReservationPopup />}

      <div
        className="min-h-screen bg-cover bg-center flex items-center justify-center px-4"
        style={{
          backgroundImage: "url('/bg.png')",
        }}
      >
        <div className="w-full max-w-md bg-[#F1F1F1] overflow-hidden shadow-2xl">
          {/* Верхняя картинка */}
          <div
            className="h-[250px] bg-cover bg-center"
            style={{
              backgroundImage: "url('/1.png')",
            }}
          ></div>

          {/* Контент */}
          <div className="py-8 px-6 text-center space-y-8">
            {/* Date */}
            <div className="space-y-1">
              <div className="text-gray-500 text-sm">Date</div>
              <div className="flex items-center justify-center gap-6 text-[17px] font-semibold leading-tight">
                <button
                  className={`text-2xl ${
                    currentDate.toDateString() === today.toDateString()
                      ? "text-gray-300 cursor-not-allowed"
                      : "text-gray-400 hover:text-black"
                  }`}
                  onClick={goPrevDate}
                  disabled={currentDate.toDateString() === today.toDateString()}
                >
                  &lt;
                </button>
                <span>{formatDate(currentDate)}</span>
                <button
                  className="text-2xl text-gray-400 hover:text-black"
                  onClick={goNextDate}
                >
                  &gt;
                </button>
              </div>
            </div>

            {/* Guests */}
            <div className="space-y-1">
              <div className="text-gray-500 text-sm">Guests</div>
              <div className="flex items-center justify-center gap-6 text-[17px] font-semibold leading-tight">
                <button
                  className={`text-2xl ${
                    guests === 1
                      ? "text-gray-300 cursor-not-allowed"
                      : "text-gray-400 hover:text-black"
                  }`}
                  onClick={() => setGuests((prev) => Math.max(prev - 1, 1))}
                  disabled={guests === 1}
                >
                  &lt;
                </button>
                <span>{guests}</span>
                <button
                  className={`text-2xl ${
                    guests === 5
                      ? "text-gray-300 cursor-not-allowed"
                      : "text-gray-400 hover:text-black"
                  }`}
                  onClick={() => setGuests((prev) => Math.min(prev + 1, 5))}
                  disabled={guests === 5}
                >
                  &gt;
                </button>
              </div>
            </div>

            {/* Time */}
            <div className="space-y-1">
              <div className="text-gray-500 text-sm">Time</div>
              <div className="flex items-center justify-center gap-6 text-[17px] font-semibold leading-tight">
                <button
                  className={`text-2xl ${
                    timeIndex === 0
                      ? "text-gray-300 cursor-not-allowed"
                      : "text-gray-400 hover:text-black"
                  }`}
                  onClick={() => setTimeIndex((prev) => Math.max(prev - 1, 0))}
                  disabled={timeIndex === 0}
                >
                  &lt;
                </button>
                <span>{time}</span>
                <button
                  className={`text-2xl ${
                    timeIndex === times.length - 1
                      ? "text-gray-300 cursor-not-allowed"
                      : "text-gray-400 hover:text-black"
                  }`}
                  onClick={() =>
                    setTimeIndex((prev) =>
                      Math.min(prev + 1, times.length - 1)
                    )
                  }
                  disabled={timeIndex === times.length - 1}
                >
                  &gt;
                </button>
              </div>
            </div>

            {/* Search Button */}
            <button
              onClick={handleSearch}
              className="w-full bg-white border border-gray-300 py-3 rounded-md text-black font-medium hover:bg-gray-200 transition"
            >
              Search
            </button>

            {/* Footer */}
            <div className="text-xs text-neutral-800 mt-2 tracking-tight">
              Experience By SEVENROOMS
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
